import type { QuizDefinition } from "@quiz/quiz-core";
import { el } from "../utils";

export function renderFlowHeader(quiz: QuizDefinition): HTMLElement {
  const header = el("header", "flow-header");
  const inner = el("div", "flow-header__inner");
  const logo = quiz.start.logo;
  if (logo?.enabled && logo.src) {
    const image = document.createElement("img");
    image.className = "flow-header__logo";
    image.src = logo.src;
    image.alt = logo.alt ?? quiz.metadata.name;
    inner.append(image);
  } else {
    inner.append(el("span", "flow-header__brand", quiz.metadata.name));
  }
  header.append(inner);
  return header;
}
